import { GatePageType } from '~/utils/types/storyblok/enums'

export default {
    '/inventory': GatePageType.INVENTORY,
    '/for-sale': GatePageType.VDP,
} as Record<string, any>
